export default function RoleEmoji({ rolename }: { rolename: string }) {
  switch (rolename) {
    case 'queen':
      return <span>👑</span>;
    case 'objective':
      return <span>🐌</span>;
    case 'warrior':
      return <span>⚔️</span>;
    case 'speed-warrior':
      return <span>⚡️</span>;
    case 'flex':
      return <span>💪</span>;
    case 'newbee':
      return <span>🐝</span>;
    case 'any':
    default:
      return <span>🤷</span>;
  }
}
